<app-dialog header="Move Inventory"
    [show]="true"
    [showHeader]="true"
    [hasControls]="false"
    [hideControlsDivider]="true"
    [hideHeaderUnderline]="form.controls.drug.value"
    [formGroup]="form"
    [disableSaveBtn]="form.invalid"
    [minWidth]="!form.controls.drug.value ? 800: 640"
>
    <app-input-search-scanner *ngIf="!form.controls.drug.value"
        [autofocus]="true"
        [isInventory]="true"
        [placeholder]="'Scan barcode (Or search drug name or NDC)'"
        [label]="'Which drug are you moving?'"
        [active]="true"
        [searchEmptyInventory]="false"
        [singleLocationResult]="searchSingleLocation"
        (optionSelected)="ndcSelected($event)"
        #searchScanner
    ></app-input-search-scanner>

    <div class="container" *ngIf="form.controls.drug.value; let drug">
        <div class="ndc-container">
            <div class="ndc">
                <div class="heading">
                    {{drug?.friendlyName}}
                </div>
                <div class="secondary">
                    {{drug?.packageNdc}}
                </div>
            </div>
            <div class="flex space-x-5">
                <app-add-note class="block cursor-pointer z-10"
                    [friendlyName]="drug?.friendlyName"
                    [note]="form?.controls?.note?.value"
                    (deleted)="removeNote(i)"
                    (submitted)="saveAddedNote($event)">
                </app-add-note>
    
                <img
                    class="delete-icon" src="assets/icons/icon-basket.svg" alt="delete" 
                    (click)="deleteNDC()"/>
             </div>
        </div>
        <app-datepicker-input [tabInd]="1"
            class="pt-5"
            label="Transaction Date/Time"
            pickerType="both"
            formControlName="transactionDateDisplayValue"
            (dateTimeChange)="dateTimeChanged($event)"
            (inputTabKeyDown)="focusFrom()"
            [dateMax]="now()"
            calendarPosition="right"
            #transactionDatePicker>
        </app-datepicker-input>
        <div class="locations">
            <app-inventory-locations-dropdown
                class="inventory-locations-dropdown from"
                label="From"
                [excludeOptions]="[form.controls.locationToId.value]"
                [positiveInventoryBalanceLocationIDs]="inventoryLocationsService.getPositiveInventoryBalanceLocationIDs(drugID)"
                [formControl]="form.controls.locationFromId"
                [tabInd]="2"
                #from
            ></app-inventory-locations-dropdown>

            <img src="assets/icons/icon-arrow-in-box.svg" class="self-end" alt="arrow" />
            
            <app-inventory-locations-dropdown
                class="inventory-locations-dropdown"
                label="To"
                [excludeOptions]="[form.controls.locationFromId.value]"
                [formControl]="form.controls.locationToId"
                [tabInd]="3"
            ></app-inventory-locations-dropdown>
        </div>
        <div class="tables" *ngIf="form.value; let formValue">
            <!-- Move from -->
            <table class="table-primary from">
                <thead>
                    <tr>
                        <th class="text-left starting-from" scope="col">
                            Starting
                        </th>
                        <th class="text-left count" scope="col">
                            Count
                        </th>
                        <th class="text-left on-hand-from" scope="col">
                            On-Hand
                        </th>
                        <th class="text-left back-count" scope="col" *ngIf="backCountEnabledForMoveFrom || backCountEnabledForMoveTo">
                            <span *ngIf="backCountEnabledForMoveFrom">BACK-COUNT OK?</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-row">
                        <td class="text-left starting-from">{{+formValue?.locationFromOnHand | number}}</td>
                        <td class="!pl-2 count">
                            <app-input
                                class="block"
                                formControlName="moveQty"
                                [type]="'number'"
                                customClasses="-mr-64 h-8"
                                [showErrors]="false"
                                textAlign="right"
                                (keyupEnter)="focusControl()"
                                (keydownTab)="focusControl()"
                                [tabInd]="4"
                                #moveQty
                            ></app-input>
                        </td>
                        <td class="text-left on-hand-from">
                            {{getMoveFromEndingQty()}}
                            <app-back-count-not-resolved-tooltip *ngIf="backCountEnabledForMoveFrom"
                                class="not-resolved-back-count"
                                [locationID]="formValue?.locationFromId"
                                [drugID]="formValue.drug.drugID"
                            ></app-back-count-not-resolved-tooltip>
                        </td>
                        <td class="text-left back-count" *ngIf="backCountEnabledForMoveFrom || backCountEnabledForMoveTo">
                            <app-yes-no-toggle *ngIf="backCountEnabledForMoveFrom"
                             [control]="form.controls.moveFromBackCountMatches"
                            ></app-yes-no-toggle>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- Move to -->
            <table class="table-primary to">
                <thead>
                    <tr>
                        <th class="text-right starting starting-to" scope="col">
                            Starting
                        </th>
                        <th class="text-right count" scope="col">
                            Count
                        </th>
                        <th class="text-right on-hand-to" scope="col">
                            On-Hand
                        </th>
                        <th class="text-left back-count" scope="col" *ngIf="backCountEnabledForMoveFrom || backCountEnabledForMoveTo">
                            <span *ngIf="backCountEnabledForMoveTo">BACK-COUNT OK?</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-row">
                        <td class="text-right starting-to">{{+formValue?.locationToOnHand | number}}</td>
                        <td class="text-right count">{{+formValue?.moveQty | number}}</td>
                        <td class="text-right on-hand-to">
                            {{getMoveToEndingQty()}}
                            <app-back-count-not-resolved-tooltip *ngIf="backCountEnabledForMoveTo"
                                class="not-resolved-back-count"
                                imgClass="pt-1"
                                [locationID]="formValue?.locationToId"
                                [drugID]="formValue.drug.drugID"
                            ></app-back-count-not-resolved-tooltip>
                        </td>
                        <td class="text-left back-count" *ngIf="backCountEnabledForMoveFrom || backCountEnabledForMoveTo">
                            <app-yes-no-toggle *ngIf="backCountEnabledForMoveTo"
                             [control]="form.controls.moveToBackCountMatches"
                            ></app-yes-no-toggle>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <app-error-message *ngIf="form.get('moveQty').errors?.max">
            The count you want to move must not exceed the starting number
        </app-error-message>
    </div>
    <div class="dialog-controls-default !border-t-0 !pt-0">
        <app-button customClasses="px-4"
                    text="Cancel"
                    [minWidth]="0"
                    subStyle="transparent"
                    class="cancel-btn"
                    (keydownTab)="focusDatePicker()"
                    (clicked)="cancel.next()"
                    #cancelButton
        ></app-button>
        <app-button customClasses="px-4"
                    [text]="'Move'"
                    class="save-btn"
                    type="submit"
                    (keydownTab)="focusDatePicker()"
                    (clicked)="save()"
                    #submitButton
        ></app-button>
    </div>
</app-dialog>   